var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('a', {
    staticClass: "thumbBox",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.linkHandler.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "imgBox",
    style: {
      '--img-width': `${_vm.imgMaxWidth}px`,
      '--img-height': `${_vm.imgMaxHeight}px`
    }
  }, [_c('img', {
    style: _vm.imgSize,
    attrs: {
      "src": `data:image/png;base64,${_vm.thumb.thumbnail}`
    }
  })]), _c('span', [_c('label', {
    domProps: {
      "innerHTML": _vm._s(_vm.thumb.processName)
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }